import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Accueil", path: "/" },
  { label: "Services", path: "/services" },
  {
    label: "Localités",
    path: "#",
    children: [
      { label: "Sion", path: "/sion" },
      { label: "Sierre", path: "/sierre" },
      { label: "Martigny", path: "/martigny" },
      { label: "Grône", path: "/grone" },
      { label: "Crans-Montana", path: "/crans-montana" },
      { label: "Verbier", path: "/verbier" },
      { label: "Nendaz", path: "/nendaz" },
      { label: "Vercorin", path: "/vercorin" },
      { label: "Nax", path: "/nax" },
    ],
  },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/images/logo.png"
            alt="Logo Carreaux-Bat"
            className="h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) =>
            link.children ? (
              <div key={link.label} className="relative">
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className={`flex items-center gap-1 text-sm font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                    scrolled ? "text-white hover:text-amber-300" : "text-white hover:text-amber-300"
                  }`}
                >
                  {link.label}
                  <i className="ri-arrow-down-s-line text-base"></i>
                </button>
                {dropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
                    {link.children.map((child) => (
                      <Link
                        key={child.path}
                        to={child.path}
                        className="block px-4 py-2 text-sm text-stone-700 hover:bg-amber-50 hover:text-amber-700 transition-colors"
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium tracking-wide transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? scrolled ? "text-amber-300" : "text-amber-300"
                    : scrolled ? "text-white hover:text-amber-300" : "text-white hover:text-amber-300"
                }`}
              >
                {link.label}
              </Link>
            )
          )}
          <Link
            to="/contact"
            className="ml-2 px-5 py-2 bg-amber-700 text-white text-sm font-medium rounded-full hover:bg-amber-800 transition-colors whitespace-nowrap"
          >
            Devis gratuit
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? "text-white" : "text-white"}`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-2xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) =>
            link.children ? (
              <div key={link.label}>
                <p className="text-xs uppercase tracking-widest text-stone-400 mb-2">Localités</p>
                {link.children.map((child) => (
                  <Link
                    key={child.path}
                    to={child.path}
                    className="block py-1.5 text-sm text-stone-700 hover:text-amber-700"
                  >
                    {child.label}
                  </Link>
                ))}
              </div>
            ) : (
              <Link
                key={link.path}
                to={link.path}
                className="text-sm font-medium text-stone-700 hover:text-amber-700"
              >
                {link.label}
              </Link>
            )
          )}
          <Link
            to="/contact"
            className="mt-2 px-5 py-2.5 bg-amber-700 text-white text-sm font-medium rounded-full text-center hover:bg-amber-800 transition-colors"
          >
            Devis gratuit
          </Link>
        </div>
      )}
    </header>
  );
}
